rootPage = $('body').data('rootpage');
// Beim Webstream wird die rootpage woanders hinterlegt
if ($('#tdAppBaseUrl').length > 0) {
    rootPage = $('#tdAppBaseUrl').data('rootpage');
}

const breakpointTiny = 360;
const breakpointSmall = 440;
const breakpointMedium = 1170;
const breakpointLarge = 1680;

const cuttrLicenseKey = 'CAB43BE5-33FE49AD-8F954B7F-42699907';
